import { useCallback, useEffect, useState } from 'react';
import useWorkspaceApiCall from 'hooks/useWorkspaceApiCall';
import { getUsersWithBasicTrainingProgresses } from 'api/services/user-service';
import { UserWithBasicTrainingsInfoModel } from 'models/UserWithBasicTrainingsInfoModel';

export const useUsersWithBasicTrainingProgresses = () => {
    const { callAPI, loading,  } = useWorkspaceApiCall(getUsersWithBasicTrainingProgresses, '', 'getSuperiors.getUsersWithBasicTrainingProgresses');

    const getUsersWithBasicTrainingProgressesMethod = useCallback(async (lessonIds: string[]) => {
        return await callAPI({ lessonIds });        
    }, [callAPI]);

    return { getUsersWithBasicTrainingProgresses: getUsersWithBasicTrainingProgressesMethod, getUsersWithBasicTrainingProgressesPending: loading };
};